import React from 'react'
import css from './style.scss'
import {connect} from 'react-redux';
import {Route} from 'react-router-dom';
import {FullPage, FullContainer} from 'components/container'
import api from './api'
import {withRouter} from 'react-router'
import Loading from 'components/shared/loading'
import AdventuresStories from '../stories'
import StoriPromo from './storiPromo'
import AccountInfo from './accountInfo'
import StoryDetails from 'components/account_page/story_details/containers/public_adventure';

const NotFoundPage=(props)=>(
  <FullContainer>
  <h3>Not Found!</h3>
  </FullContainer>
)

class AdventurePage extends React.Component{
  constructor(props){
    super(props)
    this.state={
      adventure:{},
      loading:true,
      restricted:undefined,
      closePromo:false
    }
  }
  url=()=>{
    return "/c/"+this.props.uuid
  }
  componentDidMount(){
    api.getAdventure(this.props.uuid).then(adventure => {
      this.setState({
        loading:false,
        adventure
      })
    }).catch(err=>{
      this.setState({loading:false, restricted:true})
    })
  }
  closeStoriPromo=()=>{
    this.setState({
      closePromo:true
    })
  }
  render(){
    return (
      <FullPage>
        {this.state.restricted && <NotFoundPage/>}
        {this.state.restricted!==true && this.state.loading && <Loading fullPage />}
        {this.state.restricted!==true && !this.state.loading &&
          <div>
            <div className="shadow">
              <FullContainer>
              <h1>{this.state.adventure.name}</h1>
              <AccountInfo {...this.state.adventure.account}/>
              </FullContainer>
            </div>
            <div className={css.adventurePage}>
                <FullContainer>
                  <div className={css.content}>
                    <AdventuresStories
                      stories={this.state.adventure.stories}
                      stats
                      shared
                      account_name={this.state.adventure.account.name}
                    />
                  </div>
                </FullContainer>
            </div>
            {!this.state.user && !this.state.closePromo && <StoriPromo onClose={this.closeStoriPromo} account={this.state.adventure.account}/>}
            <Route path={"/c/:uuid/:story"} render={routeProps=>{
              return (<StoryDetails {...routeProps}
                uuid={routeProps.match.params.uuid}
                storyId={routeProps.match.params.story}
                {...this.props}
                stories={this.state.adventure.stories}
              />)
            }} />
          </div>
        }

      </FullPage>
    )
  }
}


const mapStateToProps = function (state, props) {
  let uuid=props.match.params.uuid
  let user=state.user.authenticated
  //console.log(user)
  return {user, uuid};
}

export default connect(mapStateToProps)(withRouter(AdventurePage));



// WEBPACK FOOTER //
// ./src/components/adventures/public/index.js